<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />

        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-truck mr-2" />Kloter Pengiriman Emas
            </h5>
            <hr />

            <b-row class="mb-2">
                <b-col md="3">
                    <b-form-group label="Tanggal Mulai" class="mb-0">
                        <b-form-input
                            v-model="filter.start_date"
                            type="date"
                            @change="getItems"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Tanggal Akhir" class="mb-0">
                        <b-form-input
                            v-model="filter.end_date"
                            type="date"
                            @change="getItems"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Sumber" class="mb-0">
                        <b-form-select
                            v-model="filter.source"
                            :options="optFilterSource"
                            @change="getItems"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive
                class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data kloter pengiriman.
                </template>
                <template v-slot:cell(date)="row">
                    {{ $helper.parseDate(row.item.date) }}
                </template>
                <template v-slot:cell(action)="row">
                    <router-link
                        :to="'/emas/pengiriman/' + row.item.id"
                    >
                        <b-button
                            size="sm"
                            variant="primary"
                            v-b-tooltip.hover.top
                            title="Lihat Batch"
                        >
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                    </router-link>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isBusy: true,

            filter: {
                start_date: "",
                end_date: "",
                source: ""
            },

            optFilterSource: [
                { value: "", text: "Semua" },
                { value: "PEI", text: "PEI" },
                { value: "RBE", text: "RBE" }
            ],

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            fields: [
                { key: "date", label: "Tanggal Pengiriman", sortable: false },
                { key: "total_batch", label: "Total Batch", sortable: false },
                { key: "total_item", label: "Total Barang", sortable: false },
                { key: "source", label: "Sumber", sortable: false },
                { key: "action", label: "Aksi", sortable: false }
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0
        };
    },

    methods: {
        init() {
            this.initStatus = 0;
            this.getItems();
            this.initStatus = 1;
        },

        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage
            );

            if (this.filter.start_date) param += `&start_date=${this.filter.start_date}`;
            if (this.filter.end_date) param += `&end_date=${this.filter.end_date}`;
            if (this.filter.source) param += `&source=${this.filter.source}`;

            return this.$axios
                .get("gold-deliveries/deliveries" + param)
                .then(res => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        }
    },

    created() {
        this.init();
    }
};
</script>
